import styled, { css } from '../../styles/theme';
import { rem } from 'polished';
import TrimItemTemplate from './TrimItemTemplate';
import media from '../../styles/media';

export const MainTrimContaine = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .main-trim-container-disabled {
        position: absolute;
        z-index: 9999;
        top: 50%;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        padding: ${rem('10px')};
        text-align: center;
        text-transform: uppercase;
        font-weight: 700;
        font-size: ${({ theme }) => theme.fontSizes.h5};
    }
`;

export const TrimItemStyled = styled(TrimItemTemplate)`
    display: flex;
    flex-wrap: wrap;
    padding: ${rem('16px')} ${rem('10px')};
    height: 100%;

    &.with-sticker {
        align-items: flex-end;
        flex-direction: column;

        .trimContainer {
            margin-top: ${rem(10)};
        }
    }

    ${({ disabled }) =>
        disabled &&
        css`
            opacity: 0.2;
            pointer-events: none;
        `}

    .trimContainer {
        width: 100%;
        font-family: ${({ theme }) => theme.fonts.fontBase};
        grid-template-rows: 1fr auto auto 72px auto 56px auto;
        display: grid;

        .generalInfoContainer {
            width: 100%;
            display: grid;
            grid-template-rows: auto auto 1fr;

            .priceBox {
                height: auto;
                z-index: 9999999;
            }
        }

        .header {
            text-transform: uppercase;
            align-items: center;
            display: inline-grid;

            .title {
                font-weight: bold;
                font-size: ${rem('21px')};
                line-height: ${rem('28px')};
                color: ${({ theme }) => theme.colors.grey1};
                font-family: ${({ theme }) => theme.fonts.fontBase};

                ${media.lg`
                    font-size: ${rem('24px')};
                `}

                &--detail {
                    font-style: normal;
                    font-weight: 300;
                    text-transform: uppercase;
                    //white-space: nowrap;
                }
            }

            .carNumber {
                margin-right: ${rem('10px')};
            }

            h2 {
                font-size: 1.5rem;
            }

            .equipmentLevel {
                h2 {
                    font-size: 1.3rem;
                    font-weight: 200;
                }
            }
        }

        .equipmentSubtitle {
            p {
                font-weight: bold;
                font-size: ${rem('14px')};
                line-height: ${rem('20px')};
                color: rgba(20, 32, 50, 0.5);
                text-transform: uppercase;
                margin: ${rem('5px')} 0 ${rem('10px')} 0;
            }
        }

        .priceGap {
            min-height: ${rem('15px')};
        }

        .priceInfo {
            margin-top: ${rem(5)};

            &__clockIcon {
                margin-right: ${rem('5px')};
            }
            &__text {
                font-size: ${rem('14px')};
                color: ${({ theme }) => theme.colors.grey4};
                margin-top: ${rem('3px')};
                margin-bottom: ${rem('3px')};
            }
        }

        .equipmentList {
            display: flex;
            flex-direction: column;
            flex: none;

            &__info {
                font-style: normal;
                font-weight: bold;
                font-size: ${rem('14px')};
                line-height: ${rem('20px')};
                color: black;
                letter-spacing: -0.194444px;
                text-transform: uppercase;
            }

            &__list {
                margin-top: ${rem('5px')};
                margin-bottom: ${rem('5px')};
                padding-left: ${rem('17px')};
                list-style-type: disc;
                font-family: Helvetica Neue;
                font-style: normal;
                font-weight: normal;
                display: flex;
                flex-wrap: wrap;
                flex-direction: column;
            }
            &__list--item {
                font-size: ${rem('14px')};
                margin-bottom: ${rem('2px')};
                line-height: ${rem('20px')};
            }

            @-moz-document url-prefix() {
                &__list {
                    padding-left: ${rem('13px')};
                }
            }
        }

        .benefits {
            display: flex;
            flex-direction: column;
            flex: none;
            flex-wrap: nowrap;

            position: relative;
            margin-bottom: 1rem;

            .heading {
                font-style: normal;
                font-weight: bold;
                font-size: ${rem('14px')};
                line-height: ${rem('20px')};
                letter-spacing: ${rem('-0.194444px')};
                text-transform: uppercase;
            }

            ul {
                list-style: disc;
                padding-left: ${rem('20px')};
                width: 92%;

                &.bullet-points {
                    display: flex;
                    flex-wrap: wrap;
                    align-items: center;
                    padding-left: ${rem('10px')};

                    li {
                        flex-basis: 100%;
                        font-style: normal;
                        font-weight: normal;
                        font-size: ${rem('14px')};
                        line-height: ${rem('20px')};
                        position: relative;
                        display: flex;
                        &::before {
                            content: '';
                            width: ${rem('6px')};
                            min-width: ${rem('6px')};
                            display: inline-block;
                            height: ${rem('6px')};
                            margin-right: ${rem('8px')};
                            align-self: flex-start;
                            margin-top: ${rem('8px')};
                        }
                    }
                }
            }

            &__Icon {
                top: ${rem('3px')};
                position: relative;

                .vertical {
                    margin: 0;

                    > div {
                        display: flex;
                        align-items: center;
                    }
                }

                svg {
                    height: ${rem('24px')};
                    width: ${rem('24px')};
                }

                &:hover {
                    svg path:nth-child(2) {
                        fill: #fff;
                    }
                }
            }
        }

        .equipmentSelect {
            font-size: ${({ theme }) => theme.fontSizes.textBase};
            margin: ${rem('14px')} 0;
            display: block;
            cursor: pointer;
            color: ${({ theme }) => theme.colors.primary};

            .arrowIcon {
                transform: rotate(90deg);
                margin-left: ${rem('10px')};
                height: auto;

                &--open {
                    transform: rotate(-90deg);
                }

                svg {
                    path {
                        fill: ${({ theme }) => theme.colors.blue4};
                    }
                }
            }
        }

        .options {
            margin: ${rem('20px')} 0;
            font-family: Helvetica Neue;
            font-style: normal;
            font-weight: normal;
            font-size: ${rem('14px')};
            line-height: ${rem('20px')};
            color: #000000;
            display: flex;
            flex: none;

            .colorOption {
                display: flex;
                align-items: center;
                justify-content: flex-start;

                .colorButtonWrapper {
                    height: ${rem('30px')};
                    margin: 0 ${rem('10px')} 0 0;
                    flex-basis: 10%;

                    & > div {
                        height: ${rem('30px')};
                        width: ${rem('30px')};
                        border-radius: 50%;
                        padding: 0;
                    }
                }

                .colorText {
                    flex: 1;
                    height: ${rem('30px')};
                    align-items: center;
                    display: flex;
                }
            }

            .engineOption {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                margin-left: ${rem('15px')};

                .engineIcon {
                    height: ${rem('30px')};
                    margin: 0 ${rem('10px')} 0 0;
                    flex-basis: 10%;

                    svg {
                        height: ${rem('30px')};
                        width: auto;
                    }
                }

                .engineText {
                    flex: 1;
                    flex-basis: 90%;
                    height: ${rem('30px')};
                    align-items: center;
                    display: flex;
                }
            }

            a {
                text-decoration: none;
                color: ${({ theme }) => theme.colors.blue3};
            }
        }

        .buttonWrapper {
            display: flex;
            flex: none;
            margin-top: auto;
            min-width: 100%;
            justify-content: center;
            a {
                font-weight: ${({ theme }) => theme.fontWeights.textRegular};
                color: ${({ theme }) => theme.colors.white};
                padding: ${rem('15px')};
            }
        }

        .descriptionWrapper {
            display: flex;
            flex-direction: column;
            font-size: ${rem('11px')};
            line-height: ${rem('14px')};
            color: ${({ theme }) => theme.colors.grey18};
            padding: ${rem('15px')} 0;
            min-height: ${rem('140px')};

            &-payment {
                padding-bottom: ${rem('10px')};

                &-link {
                    padding-left: ${rem('5px')};
                    color: ${({ theme }) => theme.colors.primary};
                    cursor: pointer;
                    background: none;
                    padding: 0;
                    border: none;
                }
            }
        }
    }

    .carImageWrap {
        display: flex;
        flex: none;
        margin-top: ${rem('15px')};
        margin-bottom: ${rem('15px')};

        .carImage {
            width: 100%;
            max-width: ${rem('320px')};
        }
    }

    .carImageWrapWithLeadTime {
        margin: ${rem(40)} 0 !important;
    }
`;
